<!--下单-->
<template>
  <div>
    <!-- 下单 -->
    <div class="address flex-between" v-if="address.phone" @click="addressPickerShow=true">
      <div class="address-left flex-start">
        <img class="address-img" src="../../../assets/newImg/icon-address-location.png" alt />
        <div class="address-detail">
          <div class="address-pro">{{address.address}}</div> 
          <div class="address-phone">{{address.name}} {{address.phone}}</div>
        </div>
      </div>
      <div class="address-right">
        <img class="icon-right-tip" src="../../../assets/images/icon-right.png" alt />
      </div>
      <div class="address-back"></div>
    </div> 

    <div class="address flex-between" v-else  @click="addressPickerShow=true">
      <div class="address-left flex-start">
        <img class="address-img" src="../../../assets/newImg/icon-address-location.png" alt />
        <div class="address-detail">
          <div class="address-pro">请选择地址</div> 
        </div>
      </div>
      <div class="address-right">
        <img class="icon-right-tip" src="../../../assets/images/icon-right.png" alt />
      </div>
      <div class="address-back"></div>
    </div> 
        <AddressPicker :show="addressPickerShow" @onChange="changeAddress" @onClose="closeAddress" />

        <div class="savebtn" >
            <van-button
                    color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
                    style="width: 3rem"
                    size="normal" round   @click="submit">保存</van-button>
        </div>
  </div>
</template>
<style scoped>

    .savebtn {
        position: fixed;
        bottom: 0;
        padding-bottom: 0.2rem;
        width: 100%;
        z-index: 10;
        display: flex;
        flex: 1;
        flex-direction: row;
        justify-content: space-around;
        background: linear-gradient(180deg,hsla(0,0%,100%,0),#fff);
    }
.message-text {
  padding-top: 5px;
}

.message-text input::-webkit-input-placeholder {
  /* WebKit browsers */
  color: #ccc;
}

.message-text input:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #ccc;
}

.message-text input::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #ccc;
}

.message-text input:-ms-input-placeholder {
  /* Internet Explorer 10+ */
  color: #ccc;
}

.icon-right-tip {
  width: 16px;
  height: 16px;
}

.goods-box {
  max-width: 230px;
}

.van-hairline--top-bottom::after {
  border: none;
}

.van-cell {
  padding: 5px 0.31rem;
}

.address {
  padding: 0.3rem 0.2rem 0.3rem 0.36rem;
  position: relative;
}

.border-top {
  border-top: 0.1rem solid #efefef;
}

.border-bottom {
  border-bottom: 1px solid #efefef;
}

.address-img {
  width: 0.33rem;
  height: 0.42rem;
  margin-right: 0.2rem;
}

.address-detail {
  font-size: 12px;
  color: #333333;
}

.address-back {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background: url("../../../assets/newImg/bg-address-line.png");
  background-size: 1.7rem 2px;
}
 
</style>

<script> 
import AddressPicker from "@/components/AddressPicker.vue"; 
import { Field, Notify, Toast } from "vant";

export default {
  name: "OrderCheck",
  components: {
    [Field.name]: Field,
    AddressPicker, 
    Notify, 
    Toast
  },
  data: function() {
    return {
      loginShow: false,
      addressPickerShow: false,
      payDialogShow: false,
      couponPickerShow: false,
      currentCouponList: [],
      currentBusinessIndex: 0,
      currentBusinessId: 0,
      message: "",
      

      formData: {
        needLoadingIndicator: true,
        address_id: 0,
        goods_items: [],
        notes: {},
        coupon_used: {}
      },

      address: {},
      // pay_price: 0,
      orderIds: [],
      warnings: [],
      submitDisabled: true,
      submitLoading: false,

      order_list: [],
      pageData: {
        address: {
          id: 0
        },
        discounts: [],
        goods_items: [],
        goods_price: "",
        express_price: "",
        discount_price: "",
        order_price: "",
        cert_status: false
      }
    };
  },
  computed: { 
  },
  watch: { 
  },

  filter: {},
  mounted() {
    document.title = "收件地址"; 
    this.fetch();
  },
  destroyed() {},
  methods: { 
      fetch(){
        let that = this; 
        this.$api.post(
            "/api/isai/addressdetail",
            {
                baoming_id: that.$route.query.id, 
            } ,
            res => {   
                that.address = res.data
            },
            res => { 
                // Toast(res.msg)
            }
      );
      },
    changeAddress(address) {
      let that = this;
      console.log("更换地址", address);
      that.addressPickerShow = false;

      that.address.address_id = address.address_id; 
      that.address = address.address;
    },
    closeAddress() {
      let that = this;
      console.log("closeAddress");
      that.addressPickerShow = false;
    },
    // 提交订单
    submit() {
      let that = this;
      if (that.submitLoading) {
        return false;
      } 
      if(!that.address.phone){
          Notify({
            message: '请选择地址',
            duration: 2000,
            background: "#FF4444"
          });
          return ;
      }
      that.submitLoading = true;  
      that.address.baoming_id =  this.$route.query.id;
      this.$api.post(
        "/api/isai/addresssave",
        {
            address: that.address,
            baoming_id:that.address.baoming_id
        } ,
        res => {  
            Toast('保存成功')
            rbLink({
                name:'SaiApplyList'
            },'back')
        },
        res => {
          that.submitLoading = false; 
          Notify({
            message: res.msg,
            duration: 2000,
            background: "#FF4444"
          });
        }
      );
    },
 
  }
};
</script>



// WEBPACK FOOTER //
// SaiApplyAddress.vue?015d4664